import { createSelector } from 'reselect';
import { Selectors, State } from '@grandvisionhq/auth';
import { uninitState, statusSuccess, idleState } from '@grandvisionhq/state';
import { getMyAccount } from '../selectors.js';
import { ViewMode } from './state.js';

const getAddressBook = createSelector(Selectors.getAuth, getMyAccount, (auth, myAccount)=>State.isLoggedIn(auth) ? myAccount.addressBook : undefined
);
const getAddressBookList = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.list : uninitState()
);
const getAddressBookListLength = createSelector(getAddressBook, (addressBook)=>addressBook && statusSuccess(addressBook.list) ? addressBook.list.result.length : undefined
);
const getAddCall = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.add : idleState()
);
const getEditCall = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.edit : idleState()
);
const getModalState = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.modalState : {
        isOpen: false,
        viewMode: ViewMode.ADD
    }
);
const getEditedAddress = createSelector(getAddressBook, (addressBook)=>{
    return (addressBook === null || addressBook === void 0 ? void 0 : addressBook.currentlyEditingId) ? addressBook === null || addressBook === void 0 ? void 0 : addressBook.pendingListChanges[addressBook.currentlyEditingId] : undefined;
});

export { getAddCall, getAddressBook, getAddressBookList, getAddressBookListLength, getEditCall, getEditedAddress, getModalState };
//# sourceMappingURL=selectors.js.map
